module.exports = __webpack_public_path__ + "img/phone-orange.09d4eb09.svg";